import omit from 'lodash/omit'

// 从树中查找目标，结果为对象
export const findFromTree = (key, tree, config = { keyPropName: 'id', childrenPropName: 'children', leaf: false }) => {
    const { keyPropName, childrenPropName, leaf } = config

    for (let v of tree) {
        if (!leaf || !Array.isArray(v[childrenPropName])) {
            if (key === v[keyPropName]) {
                return v
            }
        }

        if (Array.isArray(v[childrenPropName]) && v[childrenPropName].length) {
            const res = findFromTree(key, v[childrenPropName], config)

            if (res) {
                return res
            }
        }
    }
}

// 打平树
export const flatTree = (tree, config = { keyPropName: 'id', childrenPropName: 'children' }, parent = []) => {
    const { childrenPropName } = config

    if (!Array.isArray(tree)) {
        return []
    }

    return tree.reduce((t, c) => {
        const children = c[childrenPropName]

        if (Array.isArray(children) && children.length) {
            const p = parent.concat(omit(c, [childrenPropName]))

            return t.concat(flatTree(children, config, p))
        }

        t.push([...parent, c])

        return t
    }, [])
}

// 从树中查找完整节点列表
export const findFullNodeFromTree = (
    key,
    tree,
    config = { keyPropName: 'id', childrenPropName: 'children', leaf: true },
) => {
    const { keyPropName, leaf } = config

    if (typeof key === 'undefined' || key === null || !Array.isArray(tree)) {
        return []
    }

    const fTree = flatTree(tree, config)

    return (
        fTree.find(v => {
            if (leaf) {
                const leafNode = v[v.length - 1]

                return key === leafNode[keyPropName]
            }

            return v.some(c => c[keyPropName] === key)
        }) || []
    )
}

// 转化树   type = 'string' 的时候 值转化为 string 列下
export const transTreeKeys = (tree, config = { keyMap: { id: 'value' }, childrenPropName: 'children', type: null }) => {
    const { keyMap, childrenPropName, type } = config

    if (!Array.isArray(tree)) {
        return []
    }

    const oldKeys = Object.keys(keyMap)

    return tree.map(v => {
        const obj = {
            ...omit(v, oldKeys),
            ...oldKeys.reduce((t, oldKey) => {
                const newKey = keyMap[oldKey]

                if (type === 'string') {
                    t[newKey] = String(v[oldKey])
                } else {
                    t[newKey] = v[oldKey]
                }

                return t
            }, {}),
        }

        const children = v[childrenPropName]

        if (Array.isArray(children)) {
            obj[childrenPropName] = transTreeKeys(children, config)
        }

        return obj
    })
}

// 转化树
export const transTreesByFieldNames = (tree, fieldNames = { name: 'label', id: 'value', childs: 'children' }) => {
    if (!Array.isArray(tree)) {
        return []
    }

    const oldKeys = Object.keys(fieldNames)

    return tree.map(v => {
        const obj = {
            ...omit(v, oldKeys),
            ...oldKeys.reduce((t, oldKey) => {
                const newKey = fieldNames[oldKey]

                t[newKey] = v[oldKey]

                return t
            }, {}),
        }

        const childPropName = oldKeys.find(k => fieldNames[k] === 'children') || 'children'

        const children = v[childPropName]

        if (Array.isArray(children)) {
            obj.children = transTreesByFieldNames(children, fieldNames)
        }

        return obj
    })
}

export const visitTree = (tree, callback) => {
    if (Array.isArray(tree)) {
        tree.forEach((v, k) => {
            callback(v, k)

            if (Array.isArray(v.children)) {
                visitTree(v.children, callback)
            }
        })
    }
}

export const flatTreeToOneLevel = (tree, config = { childrenPropName: 'children', skipHasChidlrenNode: false }) => {
    const { childrenPropName, skipHasChidlrenNode } = config

    if (!Array.isArray(tree)) {
        return []
    }

    return tree.reduce((t, c) => {
        const children = c[childrenPropName]

        const hasChildren = Array.isArray(children) && children.length

        if (!hasChildren || !skipHasChidlrenNode) {
            t.push(c)
        }

        if (hasChildren) {
            return t.concat(flatTreeToOneLevel(children, config))
        }

        return t
    }, [])
}

// 用key的列表在树中查到节点的完整信息
export const findNodeByKeyPath = (keys, tree, config = { keyPropName: 'value', childrenPropName: 'children' }) => {
    const { keyPropName, childrenPropName } = config

    if (!Array.isArray(keys) || keys.length === 0 || !Array.isArray(tree)) {
        return []
    }

    const result = []
    let currentTree = tree
    let found = false

    // 遍历key列表
    for (const key of keys) {
        const target = currentTree?.find?.(node => node[keyPropName] === key)

        if (target) {
            result.push(target)
            found = true

            currentTree = target[childrenPropName] || []
        } else {
            break
        }
    }

    // 如果完整路径都找到，返回结果；否则返回空数组
    return found ? result : []
}
